import * as React from 'react';

import { THomeowner } from '../../../containers/advancedFilters/PossessorContainer';
import { HOMEOWNER } from '../../../containers/advancedFilters/PossessorContainer/constants';
import { ESuburbanOfferFilter } from '../../../types/jsonQuery';
import { RadioButtonGroup } from '../../RadioButtonGroup';
import { Filter } from '../common/Filter';

interface IPosessorType {
  label: string;
  value: ESuburbanOfferFilter | THomeowner;
}

const POSSESSOR_TYPES: IPosessorType[] = [
  { label: 'Неважно', value: ESuburbanOfferFilter.Any },
  { label: 'От собственника', value: HOMEOWNER },
  { label: 'От застройщика', value: ESuburbanOfferFilter.Builder },
  { label: 'От собственников и агентов', value: ESuburbanOfferFilter.Individual },
];

interface IPossessorProps {
  value: ESuburbanOfferFilter | THomeowner;
  onChange(value: ESuburbanOfferFilter | THomeowner): void;
}

export const Possessor: React.FC<IPossessorProps> = ({ value, onChange }) => {
  return (
    <Filter id="advancedFilter_possessor" label="Продавец">
      <RadioButtonGroup options={POSSESSOR_TYPES} value={value} onChange={onChange} spliced={false} />
    </Filter>
  );
};
